export const FIELDS = {
  INCOMES: 'incomes',
  EMPLOYMENT_SITUATION: 'employmentSituation'
};

export const INITIAL_VALUES = {
  [FIELDS.INCOMES]: '',
  [FIELDS.EMPLOYMENT_SITUATION]: ''
};
